import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import FormMultiSelect from '../../_shared/forms/FormMultiSelect';
import FormInputNumber from '../../_shared/forms/FormInputNumber';
import { object } from 'prop-types';
import axios from 'axios';

export default class RecycleForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            recycleWaste: this.props.recycleWaste,
            error: {},
            totalPercentage: 0,
            isLoading: false,
        };
    }

    componentDidMount() {
        let totalPercentage = this.state.recycleWaste.reduce((a, b) => +a + +b.amount, 0);

        this.setState({
            totalPercentage: totalPercentage,
        });
    }

    handleMultiSelectChange = (value) => {
        let totalPercentage = value.reduce((a, b) => +a + +b.amount, 0);

        this.setState({
            recycleWaste: value,
            totalPercentage: totalPercentage,
        });
    };

    handleAmountChange = (e, id) => {
        let amount = e.target.value;

        let recycleWaste = [...this.state.recycleWaste];
        let wasteIndex = recycleWaste.findIndex((waste) => {
            return waste.id === id;
        });

        recycleWaste[wasteIndex].amount = amount;

        let totalPercentage = recycleWaste.reduce((a, b) => +a + +b.amount, 0);

        if (totalPercentage > 100) {
            let error = { id: id, message: 'Percentage cannot be higher than 100%' };
            this.setState({
                error: error,
            });
        } else {
            this.setState({
                recycleWaste: recycleWaste,
                totalPercentage: totalPercentage,
                error: {},
            });
        }
    };

    onSave = () => {
        if (Object.keys(this.state.error).length > 0) {
            return;
        }

        if (this.state.totalPercentage !== 100) {
            let error = { totalPercentage: 'Percentage must add up to 100%' };
            this.setState({
                error: error,
            });
            return;
        }

        this.setState({
            isLoading: true,
        });

        let formData = new FormData();
        formData.append('recycle_waste', JSON.stringify(this.state.recycleWaste));
        axios.post(this.props.storeUrl, formData).then(
            (res) => {
                this.setState({
                    isLoading: false,
                });

                toastr.success('Recycle rates successfully updated');
            },
            (err) => {
                this.setState({
                    isLoading: false,
                });
                console.error(err);
                toastr.error('Failed to update recycle rates, please try again');
            }
        );
    };

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-12">
                        <p>Recycled waste: {this.state.totalPercentage}%</p>
                        <div className="form-group">
                            <FormMultiSelect
                                lable="Recycle waste"
                                options={this.props.recycleWasteOptions}
                                handleMultiSelectChange={(value) => this.handleMultiSelectChange(value)}
                                classes="form-control"
                                prefixes={this.state.recycleWaste}
                            />
                        </div>
                    </div>
                </div>
                {this.state.recycleWaste &&
                    this.state.recycleWaste.map((waste) => {
                        return (
                            <div key={waste.value} className="row">
                                <hr />
                                <div className="col-md-6">
                                    <label>NAME</label>
                                    <input type="text" className="form-control" value={waste.label} disabled />
                                </div>
                                <div className="col-md-6">
                                    <FormInputNumber
                                        type="number"
                                        label="amount in %"
                                        step="1"
                                        min="1"
                                        classes={'form-control'}
                                        name="amount"
                                        value={waste.amount || ''}
                                        handleChange={(e) => this.handleAmountChange(e, waste.id)}
                                    />
                                    {this.state.error.id === waste.id && (
                                        <div className="invalid-feedback d-block">{this.state.error.message}</div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                {this.state.error.totalPercentage && (
                    <div className="row">
                        <div className="col-md-12">
                            <div className="alert-danger">
                                <p className="p-2">{this.state.error.totalPercentage}</p>
                            </div>
                        </div>
                    </div>
                )}

                <div className="row">
                    <div className="col-md-12">
                        <button className="btn btn-cw-green" onClick={this.onSave}>
                            Save
                            {this.state.isLoading && (
                                <span
                                    className="ml-1 spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                            )}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

if (document.getElementById('recycle-form')) {
    let element = document.getElementById('recycle-form');

    ReactDOM.render(
        <RecycleForm
            recycleWasteOptions={JSON.parse(element.dataset.recycle_waste_options)}
            recycleWaste={JSON.parse(element.dataset.recycle_waste)}
            job={JSON.parse(element.dataset.job)}
            storeUrl={element.dataset.store_url}
            method={element.dataset.method}
        />,
        element
    );
}
